import { OpenDataList } from "models";

export const emptyOpenData: OpenDataList = {
  id: 0,
  name: "",
  description: "",
  url: "",
};
